import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {RequestType} from '../../../services/enums/request-type.enum';
import * as _ from 'lodash';
import {NgForm} from '@angular/forms';

@AcDialog({
  width: 1000,
  height: 465,
  title: 'TEST ROUTE'
})
@Component({
  selector: 'test-route-dialog',
  templateUrl: './test-route-dialog.component.html',
  styleUrls: ['./test-route-dialog.component.scss']
})
export class TestRouteDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('sourceRouteContainer') private sourceRouteContainer: ElementRef;
  @ViewChild('testRoute') form: NgForm;

  srcNodeError = null;
  srcPConError = null;
  srcConnectionError = null;
  isOffline = false;
  regex = null;
  testRouteMode = {options: [{value: 'Live', text: 'Live'}, {value: 'Test', text: 'Test'}]};
  callTrigger = {
    options: [
      {value: 'Initial', text: 'Initial'},
      {value: '3xx', text: '3xx'},
      {value: 'Refer', text: 'Refer'},
      {value: 'Broken Connection', text: 'Broken Connection'},
      {value: 'Fax Rerouting', text: 'Fax Rerouting'}
    ]
  };
  scopeObj: any = {uri: ''};
  testRouteObject: any;
  optionsForPCons: any;
  optionsForNodes: any;
  optionsForRouters: any;
  optionsForConnections: any;
  dataObjectLocal: any;
  selectionSipHeader;
  availableSipHeadersOptions;

  sipHeadersOptions =  [
    {value: 'Contact', text: 'Contact'},
    {value: 'X-ARM-DETAIL', text: 'X-ARM-DETAIL'},
    {value: 'To', text: 'To'},
    {value: 'From', text: 'From'},
    {value: 'P-Asserted-Identity', text: 'P-Asserted-Identity'},
    {value: 'P-Preferred-Identity', text: 'P-Preferred-Identity'},
    {value: 'X-MS-UserSite', text: 'X-MS-UserSite'},
    {value: 'X-MS-UserLocation', text: 'X-MS-UserLocation'}
  ];

  isCollapsed = true;

  testRouteType = [{text: 'Call', value: RequestType.CALL}, {text: 'Register', value: RequestType.REGISTER}];

  constructor(@Inject(DIALOG_CONFIG) public dialogConfig) {
    dialogConfig.submitButtonDisabled = true;
    this.selectionSipHeader = null;
    this.isOffline = dialogConfig.dialogData.isOffline;
    this.regex = RegExp('^[A-Za-z0-9;+*#=.]*$');

    if (dialogConfig.dialogData.repeat) {
      this.scopeObj = _.cloneDeep(JSON.parse(sessionStorage.getItem( `${this.isOffline ? 'offlineMap' : 'onlineMap'}.testRoute.previousTestRoute`)));
      this.sipHeadersInitialization(this.scopeObj.sipHeaders);
    } else {
      this.scopeObj = {};
      this.scopeObj.useOnlyActiveRules = 'Live';
      this.scopeObj.callTrigger = 'Initial';
      this.scopeObj.requestType = RequestType.CALL;
      this.scopeObj.sipHeaders = [];
    }

    this.availableSipHeadersOptions = [...this.sipHeadersOptions];
    dialogConfig.dialogData.scopeObj = this.scopeObj;
    this.dataObjectLocal = dialogConfig.dialogData.dataObject;
    this.testRouteObject = dialogConfig.dialogData.testRouteObject;
    this.optionsForNodes = dialogConfig.dialogData.dataObject.nodes;
    this.optionsForPCons = [];
    this.optionsForRouters = dialogConfig.dialogData.dataObject.routers;
    this.optionsForRouters.unshift({id: -1, name: 'Any'});

    this.scopeObj.selectedConnection = null;
    this.scopeObj.router = this.scopeObj.router ? this.scopeObj.router : -1;

    if (dialogConfig.dialogData.selectedPConId) {
      this.scopeObj.selectedPCon = dialogConfig.dialogData.selectedPConId;
      this.scopeObj.selectedNode = dialogConfig.dialogData.dataObject.pCons.find((pCon) => pCon.id === this.scopeObj.selectedPCon).nodeId;
      this.optionsForPCons = dialogConfig.dialogData.dataObject.pCons.filter((pCon) => pCon.nodeId === this.scopeObj.selectedNode);

      this.scopeObj.selectedPConObj = this.dataObjectLocal.pCons.find((pCon) => pCon.id === this.scopeObj.selectedPCon);
      if (this.scopeObj.selectedPConObj.peerConnectionNodeType === 'Virtual') {
        this.initializeConnections(dialogConfig.dialogData.dataObject, this.scopeObj.selectedNode);
      }
    }
    this.dialogConfig.preSubmit = () => {
      this.initializeTestRouteObject();
      sessionStorage.setItem(`${this.isOffline ? 'offlineMap' : 'onlineMap'}.testRoute.previousTestRoute`, JSON.stringify(this.scopeObj));

      return true;
    };
  }

  ngOnInit(): void {
  }

  private sipHeadersInitialization(sipHeaders): any {
    if (_.isNil(sipHeaders) || sipHeaders.length === 0) { return; }

    sipHeaders.forEach(sipHeader => {
      if (!this.sipHeadersOptions.find(sipHeaderOption => sipHeaderOption.value === sipHeader.name)) {
        this.sipHeadersOptions.push({value: sipHeader.name, text: sipHeader.name});
      }
    });
  }

  public isReroutePconDisabled(): boolean{
    return this.scopeObj.callTrigger !== '3xx' && this.scopeObj.callTrigger !== `Refer`;
  }

  public initializeTestRouteObject(): void {
    this.testRouteObject.srcPeerConnection = this.scopeObj.selectedPCon;
    this.testRouteObject.srcNode = this.dataObjectLocal.pCons.find((pCon) => this.scopeObj.selectedPCon === pCon.id).nodeId; // TODO
    this.testRouteObject.requestType = this.scopeObj.requestType;

    this.testRouteObject.srcUser = this.scopeObj.srcUser;
    this.testRouteObject.destUser = this.scopeObj.destUser;
    this.testRouteObject.srcHost = this.scopeObj.srcHost;
    this.testRouteObject.destHost = this.scopeObj.destHost;

    const selectedPConObj = this.dataObjectLocal.pCons.find((pCon) => pCon.id === this.scopeObj.selectedPCon);
    if (selectedPConObj.peerConnectionNodeType === 'Virtual') {
      this.testRouteObject.srcConnection = this.scopeObj.selectedConnection;
    }

    this.testRouteObject.useOnlyActiveRules = this.scopeObj.useOnlyActiveRules === 'Live';
    this.testRouteObject.routerId = this.scopeObj.router === -1 ? null : this.scopeObj.router;

    this.testRouteObject.testRouteRequestSipHeaders = [...this.scopeObj.sipHeaders];

    this.callTriggerRadioToBooleans();

    if ( this.testRouteObject.isTrigger3xx === true || this.testRouteObject.isTriggerRefer === true ) {
      this.testRouteObject.srcReroutePeerConnection = this.scopeObj.selectedReroutePCon;
    }
  }

  public isRegister(): boolean {
    return this.scopeObj.requestType === RequestType.REGISTER;
  }

  private callTriggerRadioToBooleans(): void {
    this.testRouteObject.isTrigger3xx = false;
    this.testRouteObject.isTriggerRefer = false;
    this.testRouteObject.isTriggerInitialOnly = false;
    this.testRouteObject.isTriggerBrokenConnection = false;
    this.testRouteObject.isTriggerFaxRerouting = false;

    switch (this.scopeObj.callTrigger) {
      case 'Initial':
        this.testRouteObject.isTriggerInitialOnly = true;
        break;
      case '3xx':
        this.testRouteObject.isTrigger3xx = true;
        break;
      case 'Refer':
        this.testRouteObject.isTriggerRefer = true;
        break;
      case 'Broken Connection':
        this.testRouteObject.isTriggerInitialOnly = true;
        break;
      case 'Fax Rerouting':
        this.testRouteObject.isTriggerFaxRerouting = true;
        break;
    }
  }

  public nodeSelectionHandler(nodeId): void {
    this.optionsForPCons = {};
    this.optionsForPCons = this.dataObjectLocal.pCons.filter((pCon) => {
      return pCon.nodeId === nodeId;
    });
    this.scopeObj.selectedPCon = this.optionsForPCons.length >= 1 ? this.optionsForPCons[0].id : null;
    this.scopeObj.selectedPConObj = this.dataObjectLocal.pCons.find((pCon) => pCon.id === this.scopeObj.selectedPCon);
    this.initializeConnections(this.dataObjectLocal, nodeId);
  }

  private initializeConnections(dataObject, nodeId): void {
    if (this.scopeObj.selectedPCon) {
      if (this.scopeObj.selectedPConObj.peerConnectionNodeType === 'Virtual') {
        this.optionsForConnections = dataObject.connections.filter((connection) => {
          return connection.connections[0].srcNodeId === nodeId || connection.connections[0].destNodeId === nodeId;
        });
        this.scopeObj.selectedConnection = this.optionsForConnections.length > 0 ? this.optionsForConnections[0].id : null;
      }
    }

    setTimeout(() => {
      this.sourceRouteContainer.nativeElement.scrollTop = this.sourceRouteContainer.nativeElement.scrollHeight;
    });
  }

  addSipHeader(): void {
    this.updateSipHeadersOptionList();

    this.scopeObj.sipHeaders.push({
      name: '',
      value: ''
    });
  }

  sipHeaderSelected(sipHeaderId): void {
    this.selectionSipHeader = sipHeaderId;
  }

  updateSipHeadersOptionList(): void {
    const numberOfXARMDetail = this.scopeObj.sipHeaders.filter(attribute => attribute.name === 'X-ARM-DETAIL').length;
    const selectedFields = this.scopeObj.sipHeaders.map(attribute => {
      return attribute.name !== 'X-ARM-DETAIL' ? attribute.name : null;
    });

    if (numberOfXARMDetail === 3) {
      selectedFields.push('X-ARM-DETAIL');
    }

    this.availableSipHeadersOptions = this.sipHeadersOptions.filter(item => selectedFields.indexOf(item.value) === -1);
  }

  removeSipHeader(): void {
    this.scopeObj.sipHeaders.splice(this.selectionSipHeader, 1);

    this.selectionSipHeader = this.selectPreviousItem();
  }

  generateSipHeaderPlaceholder(item): string {
    return (item.name === 'X-ARM-DETAIL') ?
      'tgrp=100' : '\"100\" \<sip:100@10.7.2.10:5060>';
  }

  ngAfterViewInit(): void {
    this.form.form.valueChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = _.isNil(this.scopeObj.selectedPCon) ||
        _.isNil(this.scopeObj.selectedNode) || this.isInvalidUrls();
    });
  }

  isInvalidUrls(): boolean {
    return this.scopeObj.requestType === 'CALL' ? this.isNilOrEmpty(this.scopeObj.srcUser) && this.isNilOrEmpty(this.scopeObj.srcHost) &&
      this.isNilOrEmpty(this.scopeObj.destUser) && this.isNilOrEmpty(this.scopeObj.destHost)
      : this.isNilOrEmpty(this.scopeObj.srcUser) && this.isNilOrEmpty(this.scopeObj.srcHost);
  }

  isInvalidSipHeaders(): any {
    return this.scopeObj.sipHeaders.some((sipHeader) => {
      return !sipHeader.name || sipHeader.name === '' || !sipHeader.value || sipHeader.value === '';
    });
  }

  setOkButtonStatus(): any {
    this.dialogConfig.submitButtonDisabled = _.isNil(this.scopeObj.selectedPCon) ||
      _.isNil(this.scopeObj.selectedNode) || this.isInvalidUrls() || this.isInvalidSipHeaders();
  }

  private selectPreviousItem(): any {
    if (this.scopeObj.sipHeaders.length === 0) { return null; }

    return this.selectionSipHeader === 0 ? 0 : this.selectionSipHeader - 1;
  }

  srcNodeFocusout(): void {
    this.srcNodeError = _.isNil(this.scopeObj.selectedNode) ? 'Source Node is required' : null;
  }

  srcPConFocusout(): void {
    this.srcPConError = _.isNil(this.scopeObj.selectedPCon) ? 'Source Peer Connection is required' : null;
  }

  srcConnectionFocusout(): void {
    this.srcConnectionError = _.isNil(this.scopeObj.selectedConnection) ? 'Source Peer Connection is required' : null;
  }

  private isNilOrEmpty(value): boolean {
    return _.isNil(value) || _.isEmpty(value);
  }
}
